"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Facebook = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { className: className, height: 24, viewBox: '0 0 24 24', width: 24, xmlns: 'http://www.w3.org/2000/svg' },
        react_1.default.createElement("title", null, "Facebook Icon"),
        react_1.default.createElement("g", { fill: 'none', fillRule: 'evenodd' },
            react_1.default.createElement("path", { d: 'M20.006 3H3.994A.993.993 0 003 3.994v16.012c0 .55.445.994.994.994h8.622v-6.96h-2.339v-2.726h2.339V9.31c0-2.324 1.418-3.59 3.492-3.59.993 0 1.848.075 2.097.105v2.432h-1.43c-1.128 0-1.348.536-1.348 1.323v1.735h2.698l-.35 2.725h-2.348V21h4.58a.993.993 0 00.993-.994V3.994A.993.993 0 0020.006 3', fill: '#464650' }),
            react_1.default.createElement("path", { d: 'M0 0h24v24H0z' }))));
};
exports.default = Facebook;
